<section class="mb-8" aria-labelledby="dossier-operations-title">
    <h2 id="dossier-operations-title" class="mb-2 text-xl font-bold text-gray-800">Opérations du dossier</h2>
    <p class="mb-4 text-sm text-gray-500">Sélectionnez les opérations concernées par ce dossier.</p>

    <div class="flex flex-col items-start gap-0 md:flex-row md:gap-4">
        <mat-form-field appearance="outline" class="w-full md:basis-1/4 md:shrink-0">
            <mat-label>Date d'engagement</mat-label>
            <input matInput required class="relative -top-1" [matDatepicker]="commitmentPicker" [formControl]="dateControl" placeholder="JJ/MM/AAAA">
            <mat-datepicker-toggle matSuffix [for]="commitmentPicker"></mat-datepicker-toggle>
            <mat-datepicker #commitmentPicker></mat-datepicker>
            <mat-error>Veuillez renseigner une date d'engagement valide.</mat-error>
        </mat-form-field>

        <div class="w-full min-w-0 flex-1">
            <mat-form-field appearance="outline" floatLabel="always" class="w-full">
                <mat-label>Opérations <span aria-hidden="true">*</span></mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput aria-required="true" class="relative -top-1" [formControl]="searchControl" [placeholder]="placeholder" [matAutocomplete]="operationsAuto">
                <mat-autocomplete #operationsAuto="matAutocomplete" [displayWith]="displayOperation"
                    (optionSelected)="onAdd($event.option.value)">
                    <mat-optgroup *ngFor="let group of filteredGroups; trackBy: trackGroup" [label]="group.sector">
                        <mat-option *ngFor="let option of group.options; trackBy: trackOption" [value]="option" [matTooltip]="option.label">
                            {{ option.label }}
                        </mat-option>
                    </mat-optgroup>
                    <mat-option *ngIf="!filteredGroups.length" disabled>Aucune opération disponible</mat-option>
                </mat-autocomplete>
                <mat-hint *ngIf="!selectedOperations.length && !loading && !loadFailed">Sélectionnez au moins une opération.</mat-hint>
            </mat-form-field>

            <p *ngIf="loading" class="mb-3 text-sm text-gray-500" role="status">Chargement des opérations…</p>
            <p *ngIf="loadFailed" class="mb-3 text-sm text-warn" role="alert">Impossible de charger les opérations. Renseignez à nouveau la date d'engagement pour réessayer.</p>

            <ul *ngIf="selectedOperations.length" class="m-0 grid list-none gap-2 p-0" aria-label="Opérations sélectionnées">
                <li *ngFor="let operation of selectedOperations; trackBy: trackSelection"
                    class="flex h-8 min-w-0 items-center gap-2 rounded-md border border-accent-200 bg-accent-50 px-3 py-1 text-sm leading-tight text-accent-800 shadow-sm"
                    [matTooltip]="operation.ceeOperationFileName + ' : ' + operation.genericOperationName + (operation.cdp ? ' (Coup de pouce)' : '')">
                    <span class="min-w-0 flex-1 truncate">
                        {{ operation.ceeOperationFileName }} : {{ operation.genericOperationName }}<ng-container *ngIf="operation.cdp"> (Coup de pouce)</ng-container>
                    </span>
                    <button type="button" class="flex h-5 min-h-0 w-5 shrink-0 items-center justify-center rounded text-gray-400 hover:text-warn focus-visible:ring-2 focus-visible:ring-accent"
                        matTooltip="Retirer l'opération" [attr.aria-label]="'Retirer ' + operation.ceeOperationFileName"
                        (click)="onRemove(operation)"><mat-icon class="icon-size-4">close</mat-icon></button>
                </li>
            </ul>
        </div>

        <mat-slide-toggle *ngIf="hasCdpSelection" color="accent" class="shrink-0 pb-4 md:pb-0 md:pt-5"
            [checked]="coupDePouce" (change)="onCoupDePouceChange($event.checked)">Coup de pouce</mat-slide-toggle>
    </div>
</section>
